var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryNav(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "80px",
    viewBox: "0 0 200 80",
    enableBackground: "new 0 0 200 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    stroke: "#3371B7",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M12.8,29.5c0.6,0,1.1-0.5,1.1-1.1 c0-0.6-0.5-1.2-1.1-1.2c-0.6,0-1.2,0.5-1.2,1.2C11.6,29,12.2,29.5,12.8,29.5z M12.8,28c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C12.4,28.1,12.6,28,12.8,28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    stroke: "#3371B7",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M10,23c-3.8,0-7,3.1-7,7c0,3.8,3.1,7,7,7 s7-3.1,7-7C17,26.2,13.8,23,10,23z M10,36.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2 C16.2,33.4,13.4,36.2,10,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    stroke: "#3371B7",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M14.6,31.2c-0.1-0.1-0.2-0.2-0.3-0.2H5.7 c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2,0,0.4c0.7,2,2.5,3.3,4.6,3.3s3.9-1.3,4.6-3.3C14.7,31.5,14.7,31.3,14.6,31.2z M10,34.1 c-1.6,0-3-0.9-3.7-2.2h7.3C13,33.2,11.6,34.1,10,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    stroke: "#3371B7",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M7.2,29.5c0.6,0,1.2-0.5,1.2-1.1 c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.1,0.5-1.1,1.2C6.1,29,6.6,29.5,7.2,29.5z M7.2,28c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.4-0.2-0.4-0.4C6.8,28.1,7,28,7.2,28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M64.1,33.4l2.3,0c0.2,0,0.4,0.2,0.4,0.4v2.1c0,0.2-0.2,0.4-0.4,0.4h-2.3 c-0.2,0-0.4-0.2-0.4-0.4v-2.1C63.7,33.6,63.8,33.4,64.1,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M73.5,33.5h2.4c0.2,0,0.4,0.2,0.4,0.4v2c0,0.2-0.2,0.4-0.4,0.4h-2.4 c-0.2,0-0.4-0.2-0.4-0.4l0-2C73.1,33.6,73.3,33.5,73.5,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M63.7,28.4h12.6v5H63.7V28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M65.5,23.6h8.9c1,0,1.9,0.8,1.9,1.9v3.1H63.7v-3.1C63.7,24.5,64.5,23.6,65.5,23.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 66.2,
    cy: 30.9,
    rx: 0.9,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 73.8,
    cy: 30.9,
    rx: 0.9,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M96.4,30c0,3.6-2.9,6.5-6.4,6.5s-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5S96.4,26.4,96.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M96.3,28.6c0,0,0,0.1,0,0.1c-0.9,0.1-2.9,0.1-4.6-1.1c-1.1-0.8-2-1.7-2.6-2.5 c-0.3-0.4-0.6-0.8-0.7-1c-0.1-0.1-0.1-0.1-0.1-0.2c0.5-0.1,1.2-0.2,2-0.1c1.2,0,2.5,0.3,3.5,1.1c1,0.8,1.7,1.8,2.1,2.8 C96.1,27.9,96.2,28.3,96.3,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M84,32.2c0,0,0-0.1,0-0.1c0.9-0.2,2.9-0.4,4.7,0.6c1.1,0.7,1.9,1.5,2.4,2.3 c0.4,0.5,0.6,1,0.7,1.3c-0.4,0.1-1,0.2-1.7,0.3c-1,0-2.1-0.1-3.2-0.8s-1.9-1.6-2.4-2.5C84.2,32.8,84.1,32.5,84,32.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M116.3,26.8l-1.4,2l-0.8-0.8l-0.6-0.6l0,0.9l-0.1,8.2h-6.8 l-0.1-8.2l0-0.9l-0.6,0.6l-0.8,0.8l-1.4-2l2.6-2.9c0.1-0.1,0.2-0.1,0.3-0.1h1.3l0.4,0.7c0.7,1.3,2.6,1.3,3.3-0.1l0.3-0.6h1.2 c0.1,0,0.2,0,0.3,0.1l0.3-0.3l-0.3,0.3L116.3,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M110.1,27.7h2v0.9c0,0.4-0.4,0.7-1,0.7c-0.6,0-1-0.3-1-0.7L110.1,27.7L110.1,27.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M126.8,34.3c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2s1-2.2,2.2-2.2S126.8,33.1,126.8,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M137.6,34.3c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2 C136.6,32.1,137.6,33.1,137.6,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M126.8,24.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M137.7,24.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M126.8,23.5h10.8v2.7h-10.8C126.8,26.2,126.8,23.5,126.8,23.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    d: "M170.8,23.1L170.8,23.1c-0.3,0-0.5,0-0.8,0c-2.1,0-4,1-5.3,2.5l-0.1,0l-0.1-0.1l-1-1.2l-0.3,3.4l3.4,0.3 l-1.1-1.3l-0.1-0.1l0.1-0.1c1.1-1.5,3-2.3,5-2.1l0,0c3.2,0.3,5.5,3.1,5.2,6.3c-0.3,3-3.1,5.3-6.1,5.1c-3.1-0.2-5.4-2.9-5.3-6 l-1.3-0.1c-0.2,3.8,2.6,7.1,6.3,7.4c3.9,0.3,7.3-2.6,7.6-6.5C177.2,26.8,174.4,23.5,170.8,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    d: "M170.3,27.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v3.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2 h2.4c0.4,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.6h-1.6h-0.2v-0.2L170.3,27.4L170.3,27.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M186.2,23.4h7.7c1.5,0,2.7,1.2,2.7,2.7v7.7c0,1.5-1.2,2.7-2.7,2.7h-7.7 c-1.5,0-2.7-1.2-2.7-2.7v-7.7C183.4,24.6,184.7,23.4,186.2,23.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 186,
    cy: 28.9,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 194,
    cy: 26.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M186,33.3l0.4-0.3c0.4-0.3,1-0.3,1.5-0.1l1,0.4 c0.5,0.2,1,0.2,1.5-0.1l0.8-0.5c0.4-0.3,1-0.3,1.5-0.1l1.8,0.8"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#3371B7",
    stroke: "#3371B7",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M156,24.3c-0.2-0.1-0.4-0.1-0.5,0 c0,0-0.2,0.1-0.9,0.2c-0.7,0-2.4-0.1-3.8-0.6c-0.8-0.3-1.7-0.5-2.5-0.5c-0.2,0-0.4,0-0.5,0c-1.3,0-2.5,0.3-3.6,1 c-0.2,0.1-0.2,0.2-0.2,0.4v11.6c0,0.3,0.1,0.5,0.3,0.5c0.6,0,0.5-0.4,0.5-0.6v-5.7c0.7-0.3,3.2-1.1,5.8-0.1 c1.6,0.6,3.5,0.7,4.3,0.7c0.8,0,1.3-0.3,1.3-0.3c0.2-0.1,0.3-0.2,0.3-0.4v-5.7C156.2,24.6,156.1,24.4,156,24.3z M155.6,30.2 c-0.1,0-0.7,0.1-1,0.1c-0.7,0-2.4-0.1-3.8-0.6c-2.5-1-5-0.5-6.2-0.1v-4.9c0.9-0.5,2.2-0.7,3.2-0.7c0.1,0,0.3,0,0.4,0 c0.7,0,1.5,0.2,2.2,0.4c1.6,0.6,3.5,0.7,4.3,0.7c0.2,0,0.8,0,1-0.1V30.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M48.1,23.5h3.7c2.5,0,4.5,2,4.5,4.5c0,0.5-0.4,0.9-0.9,0.9H44.5c-0.5,0-0.9-0.4-0.9-0.9 C43.6,25.5,45.6,23.5,48.1,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M43.5,28.8c-0.2,0.1-0.5,1.2,0,1.5c1.4,1,8.5,0.8,11.3,0.6 c0.8-0.1,1.6-0.4,1.7-1.2c0-0.3-0.1-0.6-0.6-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M43.5,30.6L43.3,31c-0.2,0.5,0.2,1,0.7,0.9c0.3-0.1,0.5,0,0.7,0.3 l0.1,0.2c0.3,0.5,1,0.6,1.5,0.2l0,0c0.3-0.2,0.7-0.3,1-0.2l0.8,0.3c0.4,0.2,0.8,0.1,1.2,0l0.5-0.2c0.4-0.2,0.9-0.2,1.3,0l0.5,0.2 c0.4,0.2,0.8,0.2,1.2,0l0.2-0.1c0.3-0.2,0.8-0.2,1.1,0.1l0.2,0.2c0.3,0.3,0.8,0.2,1-0.2l0.1-0.2c0.1-0.2,0-0.3,0.2-0.3 c0.5,0,1.2-0.3,1.1-0.7l-0.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M43.5,32.2c-0.1,0.2-0.3,0.8,0,1.1c0.3,0.4,3,1.1,6.4,1.1 c2.2,0,4.6-0.3,6-0.6c0.5-0.1,0.9-0.5,0.8-0.9c0-0.2-0.2-0.5-0.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M43.5,33.3c0,0.5,0.6,2.3,1.3,2.7c1.8,0.8,5.7,0.7,8.1,0.5 c1.3-0.1,2.5-0.7,3.2-1.8c0.3-0.5,0.5-1,0.5-1.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 51.6,
    cy: 26.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 53,
    cy: 25,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 53,
    cy: 27.2,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 54.3,
    cy: 26.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 50.9,
    cy: 25,
    rx: 0.3,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    d: "M24.2,31v-7.6c0.1,0.1,0.8,0.9,2.8,3.1c2.5-1.6,5.6-0.7,6.9,0l2.4-3.1v7.1 c0,1.2-0.1,2.5-0.9,3.4c-1,1.2-2.7,2.5-5.3,2.5c-2.9,0-4.5-1.5-5.3-2.9C24.2,32.9,24.2,32,24.2,31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M21.2,30l5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M21.2,34.1l5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M38.8,30l-5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M38.8,34.1l-5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3371B7",
    d: "M29.5,32.4L29,31.7c-0.2-0.3,0-0.6,0.3-0.6h1.4 c0.3,0,0.5,0.4,0.3,0.6l-0.7,1l0,0c-0.7,1.2-2.6,1.1-3.1-0.3l-0.1-0.2c-0.1-0.2,0-0.4,0.2-0.5s0.4,0,0.5,0.2l0.1,0.2 C28.3,32.8,29.1,32.9,29.5,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3371B7",
    strokeLinecap: "round",
    d: "M32.4,32.1l-0.1,0.2c-0.4,1-1.8,1.1-2.3,0.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 27.6,
    cy: 29.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#3371B7",
    cx: 32.4,
    cy: 29.7,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    stroke: "#C0C0BF",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M12.8,49.5c0.6,0,1.1-0.5,1.1-1.1 c0-0.6-0.5-1.2-1.1-1.2c-0.6,0-1.2,0.5-1.2,1.2C11.6,49,12.2,49.5,12.8,49.5z M12.8,48c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C12.4,48.1,12.6,48,12.8,48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    stroke: "#C0C0BF",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M14.6,51.2c-0.1-0.1-0.2-0.2-0.3-0.2H5.7 c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2,0,0.4c0.7,2,2.5,3.3,4.6,3.3s3.9-1.3,4.6-3.3C14.7,51.5,14.7,51.3,14.6,51.2z M10,54.1 c-1.6,0-3-0.9-3.7-2.2h7.3C13,53.2,11.6,54.1,10,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    stroke: "#C0C0BF",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M7.2,49.5c0.6,0,1.2-0.5,1.2-1.1 c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.1,0.5-1.1,1.2C6.1,49,6.6,49.5,7.2,49.5z M7.2,48c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.4-0.2-0.4-0.4C6.8,48.1,7,48,7.2,48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    stroke: "#C0C0BF",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M10,43c-3.8,0-7,3.1-7,7c0,3.8,3.1,7,7,7 s7-3.1,7-7C17,46.2,13.8,43,10,43z M10,56.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2 C16.2,53.4,13.4,56.2,10,56.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M64.1,53.4l2.3,0c0.2,0,0.4,0.2,0.4,0.4v2.1c0,0.2-0.2,0.4-0.4,0.4h-2.3 c-0.2,0-0.4-0.2-0.4-0.4v-2.1C63.7,53.6,63.8,53.4,64.1,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M73.5,53.5h2.4c0.2,0,0.4,0.2,0.4,0.4v2c0,0.2-0.2,0.4-0.4,0.4h-2.4 c-0.2,0-0.4-0.2-0.4-0.4l0-2C73.1,53.6,73.3,53.5,73.5,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M63.7,48.4h12.6v5H63.7V48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M65.5,43.6h8.9c1,0,1.9,0.8,1.9,1.9v3.1H63.7v-3.1C63.7,44.5,64.5,43.6,65.5,43.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 66.2,
    cy: 50.9,
    rx: 0.9,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 73.8,
    cy: 50.9,
    rx: 0.9,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M96.4,50c0,3.6-2.9,6.5-6.4,6.5s-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5S96.4,46.4,96.4,50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M96.3,48.6c0,0,0,0.1,0,0.1c-0.9,0.1-2.9,0.1-4.6-1.2c-1.1-0.8-2-1.7-2.6-2.5 c-0.3-0.4-0.6-0.8-0.7-1c-0.1-0.1-0.1-0.2-0.1-0.2c0.5-0.1,1.2-0.2,2-0.2c1.2,0,2.5,0.3,3.5,1.1c1,0.8,1.7,1.8,2.1,2.8 C96.1,47.9,96.2,48.3,96.3,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M84,52.2c0,0,0-0.1,0-0.1c0.9-0.2,2.9-0.4,4.7,0.6c1.1,0.7,1.9,1.5,2.4,2.3 c0.4,0.5,0.6,1,0.7,1.3c-0.4,0.1-1,0.2-1.7,0.3c-1,0-2.1-0.1-3.2-0.8s-1.9-1.6-2.4-2.5C84.2,52.8,84.1,52.5,84,52.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M116.3,46.8l-1.4,2l-0.8-0.8l-0.6-0.7l0,0.9l-0.1,8.2h-6.8 l-0.1-8.2l0-0.9l-0.6,0.7l-0.8,0.8l-1.4-2l2.6-2.9c0.1-0.1,0.2-0.1,0.3-0.1h1.3l0.4,0.7c0.7,1.3,2.6,1.3,3.3-0.1l0.3-0.6h1.2 c0.1,0,0.2,0,0.3,0.1l0.3-0.3l-0.3,0.3L116.3,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M110.1,47.7h2v0.9c0,0.4-0.4,0.7-1,0.7c-0.6,0-1-0.3-1-0.7L110.1,47.7L110.1,47.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M126.8,54.3c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2s1-2.2,2.2-2.2S126.8,53.1,126.8,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M137.6,54.3c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2 C136.6,52.1,137.6,53.1,137.6,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M126.8,44.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M137.7,44.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M126.8,43.5h10.8v2.7h-10.8C126.8,46.2,126.8,43.5,126.8,43.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    d: "M170.8,43.1L170.8,43.1c-0.3,0-0.5,0-0.8,0c-2.1,0-4,1-5.3,2.5l-0.1,0l-0.1-0.1l-1-1.2l-0.3,3.4l3.4,0.3 l-1.1-1.3l-0.1-0.1l0.1-0.1c1.1-1.5,3-2.3,5-2.1l0,0c3.2,0.3,5.5,3.1,5.2,6.3c-0.3,3-3.1,5.3-6.1,5.1c-3.1-0.2-5.4-2.9-5.3-6 l-1.3-0.1c-0.2,3.8,2.6,7.1,6.3,7.4c3.9,0.3,7.3-2.6,7.6-6.5C177.2,46.8,174.4,43.5,170.8,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    d: "M170.3,47.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v3.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2 h2.4c0.4,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-1.6h-0.2v-0.2L170.3,47.4L170.3,47.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M186.2,43.4h7.7c1.5,0,2.7,1.2,2.7,2.7v7.7c0,1.5-1.2,2.7-2.7,2.7h-7.7 c-1.5,0-2.7-1.2-2.7-2.7v-7.7C183.4,44.7,184.7,43.4,186.2,43.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 186,
    cy: 48.9,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 194,
    cy: 46.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M186,53.3l0.4-0.3c0.4-0.3,1-0.3,1.5-0.1l1,0.4 c0.5,0.2,1,0.2,1.5-0.1l0.8-0.5c0.4-0.3,1-0.3,1.5-0.1l1.8,0.8"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C0BF",
    stroke: "#C0C0BF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M156,44.3c-0.2-0.1-0.4-0.1-0.5,0 c0,0-0.2,0.1-0.9,0.2c-0.7,0-2.4-0.1-3.8-0.6c-0.8-0.3-1.7-0.5-2.5-0.5c-0.2,0-0.4,0-0.5,0c-1.3,0-2.5,0.3-3.6,1 c-0.2,0.1-0.2,0.2-0.2,0.4v11.6c0,0.3,0.1,0.5,0.3,0.5c0.6,0,0.5-0.4,0.5-0.6v-5.7c0.7-0.3,3.2-1.1,5.8-0.1 c1.6,0.6,3.5,0.7,4.3,0.7c0.8,0,1.3-0.3,1.3-0.3c0.2-0.1,0.3-0.2,0.3-0.4v-5.7C156.2,44.6,156.1,44.4,156,44.3z M155.6,50.2 c-0.1,0-0.7,0.1-1,0.1c-0.7,0-2.4-0.1-3.8-0.6c-2.5-1-5-0.5-6.2-0.1v-4.9c0.9-0.5,2.2-0.7,3.2-0.7c0.1,0,0.3,0,0.4,0 c0.7,0,1.5,0.2,2.2,0.4c1.6,0.6,3.5,0.7,4.3,0.7c0.2,0,0.8,0,1-0.1V50.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M48.1,43.5h3.7c2.5,0,4.5,2,4.5,4.5c0,0.5-0.4,0.9-0.9,0.9H44.5c-0.5,0-0.9-0.4-0.9-0.9 C43.6,45.5,45.6,43.5,48.1,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M43.5,48.8c-0.2,0.1-0.5,1.2,0,1.5c1.4,1,8.5,0.8,11.3,0.6 c0.8-0.1,1.6-0.4,1.7-1.2c0-0.3-0.1-0.6-0.6-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M43.5,50.6L43.3,51c-0.2,0.5,0.2,1,0.7,0.9c0.3-0.1,0.5,0,0.7,0.3 l0.1,0.2c0.3,0.5,1,0.6,1.5,0.2l0,0c0.3-0.2,0.7-0.3,1-0.2l0.8,0.3c0.4,0.2,0.8,0.1,1.2,0l0.5-0.2c0.4-0.2,0.9-0.2,1.3,0l0.5,0.2 c0.4,0.2,0.8,0.2,1.2,0l0.2-0.1c0.3-0.2,0.8-0.2,1.1,0.1l0.2,0.2c0.3,0.3,0.8,0.2,1-0.2l0.1-0.2c0.1-0.2,0-0.3,0.2-0.3 c0.5,0,1.2-0.3,1.1-0.7l-0.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M43.5,52.2c-0.1,0.2-0.3,0.8,0,1.1c0.3,0.4,3,1.1,6.4,1.1 c2.2,0,4.6-0.3,6-0.6c0.5-0.1,0.9-0.5,0.8-0.9c0-0.2-0.2-0.5-0.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M43.5,53.3c0,0.5,0.6,2.3,1.3,2.7c1.8,0.8,5.7,0.7,8.1,0.5 c1.3-0.1,2.5-0.7,3.2-1.8c0.3-0.5,0.5-1,0.5-1.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 51.6,
    cy: 46.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 53,
    cy: 45,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 53,
    cy: 47.2,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 54.3,
    cy: 46.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 50.9,
    cy: 45,
    rx: 0.3,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    d: "M24.2,51v-7.6c0.1,0.1,0.8,0.9,2.8,3.1c2.5-1.7,5.6-0.7,6.9,0l2.4-3.1v7.1 c0,1.2-0.1,2.5-0.9,3.4c-1,1.2-2.7,2.5-5.3,2.5c-2.9,0-4.5-1.5-5.3-2.9C24.2,52.9,24.2,52,24.2,51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M21.2,50l5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M21.2,54.1l5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M38.8,50l-5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M38.8,54.1l-5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C0C0BF",
    d: "M29.5,52.4L29,51.7c-0.2-0.3,0-0.6,0.3-0.6h1.4 c0.3,0,0.5,0.4,0.3,0.6l-0.7,1l0,0c-0.7,1.2-2.6,1.1-3.1-0.3l-0.1-0.2c-0.1-0.2,0-0.4,0.2-0.5s0.4,0,0.5,0.2l0.1,0.2 C28.3,52.8,29.1,52.9,29.5,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C0C0BF",
    strokeLinecap: "round",
    d: "M32.4,52.1l-0.1,0.2c-0.4,1-1.8,1.1-2.3,0.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 27.6,
    cy: 49.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C0C0BF",
    cx: 32.4,
    cy: 49.7,
    rx: 0.7,
    ry: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    stroke: "#6AA9DD",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M14.6,71.2c-0.1-0.1-0.2-0.2-0.3-0.2H5.7 c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2,0,0.4c0.7,2,2.5,3.3,4.6,3.3s3.9-1.3,4.6-3.3C14.7,71.5,14.7,71.3,14.6,71.2z M10,74.1 c-1.6,0-3-0.9-3.7-2.2h7.3C13,73.2,11.6,74.1,10,74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    stroke: "#6AA9DD",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M12.8,69.5c0.6,0,1.1-0.5,1.1-1.1 c0-0.6-0.5-1.2-1.1-1.2c-0.6,0-1.2,0.5-1.2,1.2C11.6,69,12.2,69.5,12.8,69.5z M12.8,68c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C12.4,68.1,12.6,68,12.8,68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    stroke: "#6AA9DD",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M7.2,69.5c0.6,0,1.2-0.5,1.2-1.1 c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.1,0.5-1.1,1.2C6.1,69,6.6,69.5,7.2,69.5z M7.2,68c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.4-0.2-0.4-0.4C6.8,68.1,7,68,7.2,68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    stroke: "#6AA9DD",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M10,63c-3.8,0-7,3.1-7,7c0,3.8,3.1,7,7,7 s7-3.1,7-7C17,66.2,13.8,63,10,63z M10,76.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2 C16.2,73.4,13.4,76.2,10,76.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M64.1,73.4l2.3,0c0.2,0,0.4,0.2,0.4,0.4v2.1c0,0.2-0.2,0.4-0.4,0.4h-2.3 c-0.2,0-0.4-0.2-0.4-0.4v-2.1C63.7,73.6,63.8,73.4,64.1,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M73.5,73.5h2.4c0.2,0,0.4,0.2,0.4,0.4v2.1c0,0.2-0.2,0.4-0.4,0.4h-2.4 c-0.2,0-0.4-0.2-0.4-0.4l0-2.1C73.1,73.6,73.3,73.5,73.5,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M63.7,68.4h12.6v5H63.7V68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M65.5,63.6h8.9c1,0,1.9,0.8,1.9,1.9v3.1H63.7v-3.1C63.7,64.5,64.5,63.6,65.5,63.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 66.2,
    cy: 70.9,
    rx: 0.9,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 73.8,
    cy: 70.9,
    rx: 0.9,
    ry: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M96.4,70c0,3.6-2.9,6.5-6.4,6.5s-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5S96.4,66.4,96.4,70z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M96.3,68.6c0,0,0,0.1,0,0.1c-0.9,0.1-2.9,0.1-4.6-1.2c-1.1-0.8-2-1.7-2.6-2.5 c-0.3-0.4-0.6-0.8-0.7-1.1c-0.1-0.1-0.1-0.2-0.1-0.2c0.5-0.1,1.2-0.2,2-0.2c1.2,0,2.5,0.3,3.5,1.1c1,0.8,1.7,1.8,2.1,2.8 C96.1,67.9,96.2,68.3,96.3,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M84,72.2c0,0,0-0.1,0-0.1c0.9-0.2,2.9-0.4,4.7,0.6c1.1,0.7,1.9,1.5,2.4,2.3 c0.4,0.5,0.6,1,0.7,1.3c-0.4,0.1-1,0.2-1.7,0.3c-1,0-2.1-0.1-3.2-0.8s-1.9-1.6-2.4-2.5C84.2,72.8,84.1,72.4,84,72.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M116.3,66.8l-1.4,2l-0.8-0.8l-0.6-0.7l0,0.9l-0.1,8.2h-6.8 l-0.1-8.2l0-0.9l-0.6,0.7l-0.8,0.8l-1.4-2l2.6-2.9c0.1-0.1,0.2-0.1,0.3-0.1h1.3l0.4,0.7c0.7,1.3,2.6,1.3,3.3-0.1l0.3-0.6h1.2 c0.1,0,0.2,0,0.3,0.1l0.3-0.3l-0.3,0.3L116.3,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M110.1,67.7h2v0.9c0,0.4-0.4,0.7-1,0.7c-0.6,0-1-0.3-1-0.7L110.1,67.7L110.1,67.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M126.8,74.3c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2s1-2.2,2.2-2.2S126.8,73.1,126.8,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M137.6,74.3c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2 C136.6,72.1,137.6,73.1,137.6,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M126.8,64.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M137.7,64.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M126.8,63.5h10.8v2.7h-10.8C126.8,66.2,126.8,63.5,126.8,63.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    d: "M170.8,63.1L170.8,63.1c-0.3,0-0.5,0-0.8,0c-2.1,0-4,1-5.3,2.5l-0.1,0l-0.1-0.1l-1-1.2l-0.3,3.4l3.4,0.3 l-1.1-1.3l-0.1-0.1l0.1-0.1c1.1-1.4,3-2.3,5-2.1l0,0c3.2,0.3,5.5,3.1,5.2,6.3c-0.3,3-3.1,5.3-6.1,5.1c-3.1-0.2-5.4-2.9-5.3-6 l-1.3-0.1c-0.2,3.8,2.6,7.1,6.3,7.4c3.9,0.3,7.3-2.6,7.6-6.5C177.2,66.8,174.4,63.5,170.8,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    d: "M170.3,67.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v3.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2 h2.4c0.4,0,0.6-0.3,0.6-0.6S172.4,70,172,70h-1.6h-0.2v-0.2L170.3,67.4L170.3,67.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M186.2,63.4h7.7c1.5,0,2.7,1.2,2.7,2.7v7.7c0,1.5-1.2,2.7-2.7,2.7h-7.7 c-1.5,0-2.7-1.2-2.7-2.7v-7.7C183.4,64.7,184.7,63.4,186.2,63.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 186,
    cy: 68.9,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 194,
    cy: 66.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M186,73.3l0.4-0.3c0.4-0.3,1-0.3,1.5-0.1l1,0.4 c0.5,0.2,1,0.2,1.5-0.1l0.8-0.5c0.4-0.3,1-0.3,1.5-0.1l1.8,0.8"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#6AA9DD",
    stroke: "#6AA9DD",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M156,64.3c-0.2-0.1-0.4-0.1-0.5,0 c0,0-0.2,0.1-0.9,0.2c-0.7,0-2.4-0.1-3.8-0.6c-0.8-0.3-1.7-0.5-2.5-0.5c-0.2,0-0.4,0-0.5,0c-1.3,0-2.5,0.3-3.6,1 c-0.2,0.1-0.2,0.2-0.2,0.4v11.6c0,0.3,0.1,0.5,0.3,0.5c0.6,0,0.5-0.4,0.5-0.6v-5.7c0.7-0.3,3.2-1.1,5.8-0.1 c1.6,0.6,3.5,0.7,4.3,0.7c0.8,0,1.3-0.3,1.3-0.3c0.2-0.1,0.3-0.2,0.3-0.4v-5.7C156.2,64.6,156.1,64.4,156,64.3z M155.6,70.2 c-0.1,0-0.7,0.1-1,0.1c-0.7,0-2.4-0.1-3.8-0.6c-2.5-1-5-0.5-6.2-0.1v-4.9c0.9-0.5,2.2-0.7,3.2-0.7c0.1,0,0.3,0,0.4,0 c0.7,0,1.5,0.2,2.2,0.4c1.6,0.6,3.5,0.7,4.3,0.7c0.2,0,0.8,0,1-0.1V70.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M48.1,63.5h3.7c2.5,0,4.5,2,4.5,4.5c0,0.5-0.4,0.9-0.9,0.9H44.5c-0.5,0-0.9-0.4-0.9-0.9 C43.6,65.5,45.6,63.5,48.1,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M43.5,68.8c-0.2,0.1-0.5,1.2,0,1.5c1.4,0.9,8.5,0.8,11.3,0.6 c0.8-0.1,1.6-0.4,1.7-1.2c0-0.3-0.1-0.6-0.6-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M43.5,70.6L43.3,71c-0.2,0.5,0.2,1,0.7,0.9c0.3-0.1,0.5,0.1,0.7,0.3 l0.1,0.2c0.3,0.5,1,0.6,1.5,0.2l0,0c0.3-0.2,0.7-0.3,1-0.2l0.8,0.3c0.4,0.2,0.8,0.1,1.2,0l0.5-0.2c0.4-0.2,0.9-0.2,1.3,0l0.5,0.2 c0.4,0.2,0.8,0.2,1.2-0.1l0.2-0.1c0.3-0.2,0.8-0.2,1.1,0.1l0.2,0.2c0.3,0.3,0.8,0.2,1-0.2l0.1-0.2c0.1-0.2,0-0.3,0.2-0.3 c0.5,0,1.2-0.3,1.1-0.7l-0.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M43.5,72.2c-0.1,0.2-0.3,0.8,0,1.1c0.3,0.4,3,1.1,6.4,1.1 c2.2,0,4.6-0.3,6-0.6c0.5-0.1,0.9-0.4,0.8-0.9c0-0.2-0.2-0.5-0.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M43.5,73.3c0,0.5,0.6,2.3,1.3,2.7c1.8,0.8,5.7,0.7,8.1,0.5 c1.3-0.1,2.5-0.7,3.2-1.8c0.3-0.5,0.5-1,0.5-1.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 51.6,
    cy: 66.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 53,
    cy: 65,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 53,
    cy: 67.2,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 54.3,
    cy: 66.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 50.9,
    cy: 65,
    rx: 0.3,
    ry: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    d: "M24.2,71v-7.6c0.1,0.1,0.8,0.9,2.8,3.1c2.5-1.7,5.6-0.7,6.9,0l2.4-3.1v7.1 c0,1.2-0.1,2.5-0.9,3.4c-1,1.2-2.7,2.5-5.3,2.5c-2.9,0-4.5-1.5-5.3-2.9C24.2,72.9,24.2,72,24.2,71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M21.2,70.1l5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M21.2,74.1l5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M38.8,70.1l-5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M38.8,74.1l-5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6AA9DD",
    d: "M29.5,72.4L29,71.7c-0.2-0.3,0-0.6,0.3-0.6h1.4 c0.3,0,0.5,0.4,0.3,0.6l-0.7,1l0,0c-0.7,1.2-2.6,1.1-3.1-0.3l-0.1-0.2c-0.1-0.2,0-0.4,0.2-0.5c0.2-0.1,0.4,0,0.5,0.2l0.1,0.2 C28.3,72.8,29.1,72.9,29.5,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6AA9DD",
    strokeLinecap: "round",
    d: "M32.4,72.1l-0.1,0.2c-0.4,1-1.8,1.1-2.3,0.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 27.6,
    cy: 69.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6AA9DD",
    cx: 32.4,
    cy: 69.7,
    rx: 0.7,
    ry: 0.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M12.8,9.5c0.6,0,1.1-0.5,1.1-1.2 c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.2,0.5-1.2,1.1S12.2,9.5,12.8,9.5z M12.8,7.9c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.4-0.2-0.4-0.4C12.4,8.1,12.6,7.9,12.8,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M7.2,9.5c0.6,0,1.2-0.5,1.2-1.2 c0-0.6-0.5-1.1-1.2-1.1c-0.6,0-1.1,0.5-1.1,1.1S6.6,9.5,7.2,9.5z M7.2,7.9c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4 C7,8.7,6.8,8.5,6.8,8.3C6.8,8.1,7,7.9,7.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M14.6,11.2c-0.1-0.1-0.2-0.2-0.3-0.2H5.7 c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2,0,0.4c0.7,2,2.5,3.3,4.6,3.3s3.9-1.3,4.6-3.3C14.7,11.4,14.7,11.3,14.6,11.2z M10,14.1 c-1.6,0-3-0.9-3.7-2.2h7.3C13,13.2,11.6,14.1,10,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    d: "M10,3c-3.8,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7 S13.8,3,10,3z M10,16.2c-3.4,0-6.2-2.8-6.2-6.2S6.6,3.8,10,3.8s6.2,2.8,6.2,6.2S13.4,16.2,10,16.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Car_00000018935395085413413750000000825273877842775715_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M64.1,13.4l2.3,0c0.2,0,0.4,0.2,0.4,0.4v2.1c0,0.2-0.2,0.4-0.4,0.4h-2.3 c-0.2,0-0.4-0.2-0.4-0.4v-2.1C63.7,13.6,63.8,13.4,64.1,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M73.5,13.4h2.4c0.2,0,0.4,0.2,0.4,0.4v2.1c0,0.2-0.2,0.4-0.4,0.4h-2.4 c-0.2,0-0.4-0.2-0.4-0.4l0-2.1C73.1,13.6,73.3,13.4,73.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M63.7,8.4h12.6v5H63.7V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M65.5,3.6h8.9c1,0,1.9,0.8,1.9,1.9v3.1H63.7V5.5C63.7,4.4,64.5,3.6,65.5,3.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 66.2,
    cy: 10.9,
    rx: 0.9,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 73.8,
    cy: 10.9,
    rx: 0.9,
    ry: 0.9
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Activities"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M96.4,10c0,3.6-2.9,6.5-6.4,6.5s-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5S96.4,6.4,96.4,10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M96.3,8.6c0,0,0,0.1,0,0.1c-0.9,0.1-2.9,0.1-4.6-1.2c-1.1-0.8-2-1.7-2.6-2.5 c-0.3-0.4-0.6-0.8-0.7-1.1c-0.1-0.1-0.1-0.2-0.1-0.2c0.5-0.1,1.2-0.2,2-0.2c1.2,0,2.5,0.3,3.5,1.1c1,0.8,1.7,1.8,2.1,2.8 C96.1,7.9,96.2,8.3,96.3,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M84,12.1c0,0,0-0.1,0-0.1c0.9-0.2,2.9-0.4,4.7,0.6c1.1,0.6,1.9,1.5,2.4,2.3 c0.4,0.5,0.6,1,0.7,1.3c-0.4,0.1-1,0.2-1.7,0.3c-1,0-2.1-0.1-3.2-0.8c-1.1-0.6-1.9-1.6-2.4-2.5C84.2,12.8,84.1,12.4,84,12.1z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Objects_00000064312371739130315250000010225889032228632975_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M116.3,6.8l-1.4,2L114.1,8l-0.6-0.7l0,0.9l-0.1,8.2h-6.8l-0.1-8.2 l0-0.9L105.9,8l-0.8,0.8l-1.4-2l2.6-2.9c0.1-0.1,0.2-0.1,0.3-0.1h1.3l0.4,0.7c0.7,1.3,2.6,1.3,3.3-0.1l0.3-0.6h1.2 c0.1,0,0.2,0,0.3,0.1l0.3-0.3l-0.3,0.3L116.3,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M110.1,7.7h2v0.9c0,0.4-0.4,0.7-1,0.7c-0.6,0-1-0.3-1-0.7L110.1,7.7L110.1,7.7z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Symbols_00000096746907869929921180000006484812830282582416_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M126.8,14.3c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2s1-2.2,2.2-2.2S126.8,13.1,126.8,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M137.6,14.3c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2 C136.6,12.1,137.6,13.1,137.6,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M126.8,4.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M137.7,4.4v9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M126.8,3.5h10.8v2.7h-10.8C126.8,6.2,126.8,3.5,126.8,3.5z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Recents"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M170.8,3.1L170.8,3.1c-0.3,0-0.5,0-0.8,0c-2.1,0-4,1-5.3,2.5l-0.1,0l-0.1-0.1l-1-1.2l-0.3,3.4l3.4,0.3 l-1.1-1.3l-0.1-0.1l0.1-0.1c1.1-1.4,3-2.3,5-2.1l0,0c3.2,0.3,5.5,3.1,5.2,6.3c-0.3,3-3.1,5.3-6.1,5.1c-3.1-0.2-5.4-2.9-5.3-6 L163,9.5c-0.2,3.8,2.6,7.1,6.3,7.4c3.9,0.4,7.3-2.6,7.6-6.5C177.2,6.8,174.4,3.5,170.8,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M170.3,7.4c0-0.3-0.3-0.6-0.6-0.6S169,7.1,169,7.4v3.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2 h2.4c0.4,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6h-1.6h-0.2V9.8L170.3,7.4L170.3,7.4z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Custom_00000181087229434302336780000005152277945940674488_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M186.2,3.4h7.7c1.5,0,2.7,1.2,2.7,2.7v7.7c0,1.5-1.2,2.7-2.7,2.7h-7.7 c-1.5,0-2.7-1.2-2.7-2.7V6.1C183.4,4.6,184.7,3.4,186.2,3.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 186,
    cy: 8.9,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 194,
    cy: 6.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M186,13.3l0.4-0.3c0.4-0.3,1-0.3,1.5-0.1l1,0.4 c0.5,0.2,1,0.2,1.5-0.1l0.8-0.5c0.4-0.3,1-0.3,1.5-0.1l1.8,0.8"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    stroke: "#868686",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M156,4.3c-0.2-0.1-0.4-0.1-0.5,0 c0,0-0.2,0.1-0.9,0.1c-0.7,0-2.4-0.1-3.8-0.6c-0.8-0.3-1.7-0.5-2.5-0.5c-0.2,0-0.4,0-0.5,0c-1.3,0-2.5,0.3-3.6,1 c-0.2,0.1-0.2,0.2-0.2,0.4v11.6c0,0.3,0.1,0.5,0.3,0.5c0.6,0,0.5-0.4,0.5-0.6v-5.7c0.7-0.3,3.2-1.1,5.8-0.1c1.6,0.6,3.5,0.7,4.3,0.7 c0.8,0,1.3-0.3,1.3-0.3c0.2-0.1,0.3-0.2,0.3-0.4V4.7C156.2,4.5,156.1,4.4,156,4.3z M155.6,10.2c-0.1,0-0.7,0.1-1,0.1 c-0.7,0-2.4-0.1-3.8-0.6c-2.5-1-5-0.5-6.2-0.1V4.7c0.9-0.5,2.2-0.7,3.2-0.7c0.1,0,0.3,0,0.4,0c0.7,0,1.5,0.2,2.2,0.4 c1.6,0.6,3.5,0.7,4.3,0.7c0.2,0,0.8,0,1-0.1V10.2z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Food"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M48.1,3.5h3.7c2.5,0,4.5,2,4.5,4.5c0,0.5-0.4,0.9-0.9,0.9H44.5c-0.5,0-0.9-0.4-0.9-0.9 C43.6,5.5,45.6,3.5,48.1,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M43.5,8.7c-0.2,0.1-0.5,1.2,0,1.5c1.4,0.9,8.5,0.8,11.3,0.6 c0.8-0.1,1.6-0.4,1.7-1.2c0-0.3-0.1-0.6-0.6-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M43.5,10.6L43.3,11c-0.2,0.5,0.2,1,0.7,0.9 c0.3-0.1,0.5,0.1,0.7,0.3l0.1,0.2c0.3,0.5,1,0.6,1.5,0.2l0,0c0.3-0.2,0.7-0.3,1-0.2l0.8,0.3c0.4,0.1,0.8,0.1,1.2,0l0.5-0.2 c0.4-0.2,0.9-0.2,1.3,0l0.5,0.2c0.4,0.2,0.8,0.1,1.2-0.1l0.2-0.1c0.3-0.2,0.8-0.1,1.1,0.1l0.2,0.2c0.3,0.3,0.8,0.2,1-0.2l0.1-0.2 c0.1-0.2,0-0.3,0.2-0.4c0.5,0,1.2-0.3,1.1-0.7l-0.4-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M43.5,12.1c-0.1,0.2-0.3,0.8,0,1.1c0.3,0.4,3,1.1,6.4,1.1 c2.2,0,4.6-0.3,6-0.6c0.5-0.1,0.9-0.4,0.8-0.9c0-0.2-0.2-0.5-0.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M43.5,13.3c0,0.5,0.6,2.4,1.3,2.6c1.8,0.8,5.7,0.7,8.1,0.5 c1.3-0.1,2.5-0.7,3.2-1.8c0.3-0.5,0.5-1,0.5-1.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 51.6,
    cy: 6.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 53,
    cy: 4.9,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 53,
    cy: 7.2,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 54.3,
    cy: 6.5,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 50.9,
    cy: 4.9,
    rx: 0.3,
    ry: 0.4
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Animals"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    d: "M24.2,11V3.5c0.1,0.1,0.8,0.9,2.8,3.1c2.5-1.7,5.6-0.7,6.9,0l2.4-3.1v7.1 c0,1.2-0.1,2.5-0.9,3.4c-1,1.2-2.7,2.5-5.3,2.5c-2.9,0-4.5-1.5-5.3-2.9C24.2,12.9,24.2,11.9,24.2,11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M21.2,10l5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M21.2,14.1l5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M38.8,10l-5.4,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M38.8,14.1l-5.4-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#868686",
    d: "M29.5,12.4L29,11.7c-0.2-0.3,0-0.6,0.3-0.6h1.4 c0.3,0,0.5,0.4,0.3,0.6l-0.7,1l0,0c-0.7,1.2-2.6,1.1-3.1-0.3l-0.1-0.2c-0.1-0.2,0-0.4,0.2-0.5s0.4,0,0.5,0.2l0.1,0.2 C28.3,12.7,29.1,12.9,29.5,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#868686",
    strokeLinecap: "round",
    d: "M32.4,12.1l-0.1,0.2c-0.4,1-1.8,1.1-2.3,0.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 27.6,
    cy: 9.7,
    rx: 0.7,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#868686",
    cx: 32.4,
    cy: 9.7,
    rx: 0.7,
    ry: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryNav);
export default __webpack_public_path__ + "static/media/CategoryNav.c911e7cf888ecd88aeb807a6960bcf52.svg";
export { ForwardRef as ReactComponent };